// STUB — to be replaced by the police agent. Must export `PoliceSystem` (with `.wanted`).
import { G } from './ctx';
import type { CrimeKind, IPed, IPoliceSystem, IVehicle, IWanted } from './types';

class Wanted implements IWanted {
  level = 0;
  heat = 0;
  inSight = false;
  reportCrime(kind: CrimeKind, x: number, z: number): void {
    void x;
    void z;
    const w: Record<CrimeKind, number> = { ped_hit: 0.3, ped_killed: 0.7, car_theft: 0.4, shot_fired: 0.15, cop_attacked: 1, cop_killed: 1.5, explosion: 1, vehicle_destroyed: 0.6 };
    this.heat += w[kind];
    while (this.heat >= 1 && this.level < 5) {
      this.heat -= 1;
      this.setLevel(this.level + 1);
    }
  }
  setLevel(level: number): void {
    const prev = this.level;
    this.level = Math.max(0, Math.min(5, level));
    if (prev !== this.level) G.events.emit('wantedChanged', { level: this.level, previous: prev });
  }
  clear(): void {
    this.setLevel(0);
    this.heat = 0;
  }
}

export class PoliceSystem implements IPoliceSystem {
  wanted: IWanted = new Wanted();
  cops: IPed[] = [];
  copCars: IVehicle[] = [];
  constructor() {
    G.events.on('crime', (e) => this.wanted.reportCrime(e.kind, e.x, e.z));
  }
  update(dt: number): void {
    void dt;
  }
}
